import { getCollectedPaymentsApiCall, getReceivablesApiCall, reconcileCashRevenueApiCall } from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

// FIN-1.6 parallel-run reporting: the sanctioned ledger cash figure vs the legacy
// naive sum for the same window. `reconcileCashRevenue` returns ledgerCashCents,
// legacyPaidCents and deltaCents in one call (delta = the credit consumption the old
// SUM wrongly counted as revenue).
export const GET_LEDGER_RECONCILIATION = { entity: 'GET_LEDGER_RECONCILIATION', action: Action.GET_ONE };

export const getLedgerReconciliation = (from, to) => async dispatch =>
  execute(dispatch, () => reconcileCashRevenueApiCall({ from, to }), GET_LEDGER_RECONCILIATION, false, true);

// PAY-1 / iMove F3 — "Pagamenti da riscuotere" (receivables): the provider-scoped list
// of orders that still have cash to collect, derived from the ledger (never the legacy
// `paid` boolean). Credit-settled and wallet top-up orders are excluded by the backend.
export const GET_RECEIVABLES = { entity: 'GET_RECEIVABLES', action: Action.GET_MANY };

export const getReceivables = () => async dispatch => execute(dispatch, () => getReceivablesApiCall(), GET_RECEIVABLES, false, true);

// PAY-1 / iMove F2 — "Pagamenti" (collected payments): the individual cash ledger rows
// for the window (the line items behind the cash-revenue total), optionally filtered by
// payment method.
export const GET_COLLECTED_PAYMENTS = { entity: 'GET_COLLECTED_PAYMENTS', action: Action.GET_MANY };

export const getCollectedPayments = (from, to, method) => async dispatch =>
  execute(dispatch, () => getCollectedPaymentsApiCall({ from, to, method: method || null }), GET_COLLECTED_PAYMENTS, false, true);

export const ledgerReportingReducers = {
  reconciliation: basicReducer(GET_LEDGER_RECONCILIATION),
  receivables: basicReducer(GET_RECEIVABLES),
  collectedPayments: basicReducer(GET_COLLECTED_PAYMENTS),
};
